import React from 'react';
import {FormattedMessage} from 'react-intl';
import * as tracking from '../tracking';
import {hasPermission} from '../forecast-app/shared/util/PermissionsUtil';
import Util from '../forecast-app/shared/util/util';
import LogoutMutation from '../mutations/logout_mutation';
import {PERMISSION_TYPE} from '../Permissions';

const SUPPORT_EMAIL = 'support@forecast.app';

/**
 * Signs the person out and leaves the app with a full page load, the same way the trial-end page does.
 * A router push would not do: the blocked page replaces the whole app, so it would just re-render over
 * whatever route the push landed on.
 */
const logOut = (): void => {
	Util.CommitMutation(LogoutMutation, null, () => {
		tracking.logout();
		window.location.href = window.location.origin;
	});
};

const Message = (): JSX.Element => {
	const adminOrFullAccess = hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS);
	const supportHref = (
		<a className="mailto" href={`mailto:${SUPPORT_EMAIL}`}>
			{adminOrFullAccess ? <FormattedMessage id="access_blocked.admin_support_info_2" /> : SUPPORT_EMAIL}
		</a>
	);

	return (
		<div>
			{adminOrFullAccess ? (
				<h2>
					<FormattedMessage id="access_blocked.title" />
				</h2>
			) : null}
			<div>
				<FormattedMessage id="access_blocked.info_title" />, <br /> <br />
				{adminOrFullAccess ? (
					<div>
						<FormattedMessage id="access_blocked.info_admin_1" />
					</div>
				) : (
					<div>
						<FormattedMessage id="access_blocked.info_team_member" />
						{supportHref}
					</div>
				)}
			</div>
			<br />
			{adminOrFullAccess ? (
				<div>
					<FormattedMessage id="access_blocked.admin_support_info_1" />
					{supportHref}
					<FormattedMessage id="access_blocked.admin_support_info_3" />
				</div>
			) : null}
			<br />
			<br />
			<div>- The Forecast Team</div>
		</div>
	);
};

/**
 * The full page shown when a company's access is blocked. Presentational only — it takes no data and
 * performs no navigation, so `appv2` can render it in place of the entire app (header, routes and all)
 * without going through the router. `access_blocked.js` renders the same page for `/access-blocked`.
 *
 * There is deliberately no link to `/settings/subscription`: the block is absolute, so that page cannot
 * render either. Admins are pointed at support instead. Logging out is the one action still available,
 * because this page stands in for the header that would otherwise offer it.
 */
const AccessBlockedContent = (): JSX.Element => (
	<div className="fullscreen fullscreen-centered-outer access-blocked">
		<div className="fullscreen-centered-inner">
			<div className="fullscreen-centered-content">
				<div>
					<Message />
				</div>
				<div className="button-container">
					<button type="button" onClick={logOut}>
						<FormattedMessage id="header.log-out" />
					</button>
				</div>
			</div>
		</div>
	</div>
);

export default AccessBlockedContent;
